import { useCallback, useState } from 'react';

import {
  IRelatedOrdersDto,
  IShipmentEntity,
  PaginationQuery,
  RelatedOrdersDto,
} from '@project44-models/shipment-list';

import { fetchRelatedOrders } from './fetchRelatedOrders';

function useRelatedOrders() {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<IRelatedOrdersDto>({
    shipment: {
      shipmentId: '',
      sharingContext: {
        dataOriginators: [],
        recipients: [],
      },
    } as unknown as IShipmentEntity,
    relatedOrders: {
      paginationInfo: {},
      results: [],
    },
  });

  const doFetch = useCallback(
    async (shipmentId: string, paging?: PaginationQuery) => {
      setIsError(false);
      setIsLoading(true);
      await fetchRelatedOrders({ shipmentId, paging })
        .then((data) => {
          setData(data);
          setIsLoading(false);
        })
        .catch(() => {
          setIsError(true);
          setIsLoading(false);
        });
    },
    [],
  );

  return {
    doFetch,
    data: RelatedOrdersDto.fromJSON(Object.assign(data)),
    isLoading,
    isError,
  };
}

export default useRelatedOrders;
